import * as usersAPI from '../api/services/usersApi';
import {
  setToken,
  removeToken,
  getUserFromToken,
} from '../utils/auth/tokenService';

export async function signUp(userData) {
  // Delegate the network request code to the users-api.js service module
  try {
    const token = await usersAPI.signUp(userData);
    setToken(token);
    return getUserFromToken();
  } catch {
    throw new Error('Invalid Sign Up');
  }
}

export async function login(credentials) {
  try {
    const token = await usersAPI.login(credentials);
    setToken(token);
    return getUserFromToken();
  } catch {
    throw new Error('Bad Credentials');
  }
}

export async function verifyCredentials(id, credentials) {
  return await usersAPI.verifyCredentials(id, credentials);
}

export async function checkAvailability(credentials) {
  return await usersAPI.checkAvailability(credentials);
}

export async function getUsers() {
  return await usersAPI.getAllUsers();
}

export async function getMe() {
  return await usersAPI.getMe();
}

export async function addUser(id) {
  return await usersAPI.addUser(id);
}

export async function updateUser(id, userData) {
  return await usersAPI.updateUser(id, userData);
}

export async function updateUserPassword(id, userData) {
  return await usersAPI.updateUserPassword(id, userData);
}

export async function deleteUser(id) {
  return await usersAPI.deleteUser(id);
}

export function logOut() {
  removeToken();
}
